<template>
  <div class="line-chart">
    <x-loading
      v-if="loading || !completeLoading"
      :visible="loading"
      class="chart-preview"
      @loading-done="handleLoadingDone"
    >
    </x-loading>
    <div class="holding-center">
      <v-chart
        v-if="data && data.length > 0"
        ref="chart"
        :options="options"
        :theme="theme"
        class="inner-chart" />
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/legendScroll'
// import 'echarts/lib/component/dataZoom'
// import 'echarts/lib/component/dataZoomSlider'
import theme from './dap-chart-theme.json'
import apis from '@/api'
import 'echarts/lib/chart/line'
import ChartMixin from './chart.mixin'
export default {
  name: 'LineChart',
  components: {
    'v-chart': ECharts
  },
  mixins: [ChartMixin],
  props: {
    chartConfig: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      data: [],
      theme: theme,
      loading: false,
      completeLoading: true
    }
  },
  computed: {
    options: function() {
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          },
          show: true
        },
        legend: {
          orient: 'horizontal',
          x: 'center',
          padding: [5, 30],
          bottom: 10,
          textStyle: {
            color: '#000000',
            fontSize: 12
          },
          show: true,
          type: 'scroll',
          data: this.legendData.map((item) => item.name)
        },
        grid: {
          left: 30,
          right: 30,
          bottom: 45,
          top: 20,
          containLabel: true,
          show: true
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: this.renderSence === 'render',
        //     start: 0,
        //     end: 100,
        //     xAxisIndex: 0,
        //     showDetail: true
        //   }
        // ],
        yAxis: [
          {
            type: 'value',
            name: this.chartConfig.yAxisTitle,
            axisLine: {
              show: true
            },
            axisTick: {
              alignWithLabel: true
            },
            max: y => this.getMaxY(y.max)
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: this.parseDimension,
            axisLabel: {
              interval: 0,
              formatter: (value, index) => this.xAxisFormatter(value, index)
            }
          }
        ],
        series: this.legendData.map((x) => {
          return {
            name: x.name,
            data: x.value,
            type: 'line',
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: 'black',
                    fontSize: 12
                  }
                }
              }
            },
            markLine: {
              silent: false,
              precision: 2,
              label: {
                show: this.guidelines
              },
              symbol: ['none', 'none'],
              data: this.guidelines.map((item) => {
                return {
                  yAxis: parseFloat(item.guidelineValue),
                  label: {
                    formatter: (params) => {
                      return this.formatterMarkLine(item.guidelineName, params)
                    },
                    position: 'insideStartTop',
                    show: true
                  },
                  lineStyle: {
                    color: item.guidelineColor
                  }
                }
              }),
              lineStyle: {
                normal: {
                  type: 'dashed'
                }
              }
            }
          }
        })
      }
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    handleLoadingDone() {
      this.completeLoading = true
    },
    queryGuideLines() {
      const request = this.renderSence !== 'render'
        ? {
          ...apis.FORM.CALCULATE_GUIDE_LINE,
          params: {
            ...this.chartConfig
          }
        }
        : {
          ...apis.FORM.QUERY_GUIDE_LINE,
          params: {
            reportFormId: this.$route.query.formId,
            chartUuid: this.chartConfig.uuid
          }
        }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (this.chartConfig && this.chartConfig.guidelines) {
              const temp = this.chartConfig.guidelines.map((item, index) => {
                if (resp.data.length > index) {
                  return { ...item, ...resp.data[index] }
                } else {
                  return item
                }
              })
              this.$emit('configChange', {
                guidelines: temp
              }, true)
            }
          },
          () => {
            //
          }
        )
        .asyncErrorCatch(() => {
          //
        })
    },
    queryData() {
      const request = this.renderSence !== 'render'
        ? {
          ...apis.FORM.QUERY_LINE_DATA,
          params: {
            ...this.chartConfig
          }
        }
        : {
          ...apis.FORM.GET_LINE_DATA,
          params: {
            reportFormId: this.$route.query.formId,
            chartUuid: this.chartConfig.uuid
          }
        }
      this.loading = true
      this.completeLoading = false
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.data = resp.data.chartDatas
            setTimeout(() => {
              this.resizeTheChart()
            }, 300)
            if (this.data && this.data.length) {
              setTimeout(() => {
                this.loading = false
              }, this.data.length * 4)
            } else {
              this.loading = false
            }
            try {
              this.renderData()
            } catch (error) {
              this.data = []
            }
            // this.resizeTheChart()
          },
          () => {
            this.loading = false
            this.$emit('error')
          }
        )
        .asyncErrorCatch(() => {
          this.loading = false
          this.$emit('error')
        })
    }
  }
}
</script>

<style lang="scss">
.line-chart {
  height: 14.7rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  .chart-preview {
    height: 100%;
    width: auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    background: $--app-light-color;
    right: 0;
  }
  .x-loading, .x-loading > img {
    margin: auto;
    height: 100%;
  }
  .x-loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .holding-center {
    width: 100%;
    height: 100%;
    overflow: auto hidden;
    display: block;
    .inner-chart {
      height: 100%;
      width: auto;
      overflow-x: hidden;
    }
    .empty-line {
      height: 100%;
    }
  }
}
</style>
